const INSTALL_DISMISSED_KEY = "f13-pwa-install-dismissed";
const INSTALL_DISMISS_DAYS = 14;

const androidInstallBanner = document.getElementById("android-install-banner");
const iosInstallBanner     = document.getElementById("ios-install-banner");

let deferredPrompt = null;

function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

function isPWAInstalled() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.matchMedia("(display-mode: minimal-ui)").matches ||
    window.navigator.standalone === true
  );
}

// PWA Android
window.addEventListener("beforeinstallprompt", (event) => {
  if (isPWAInstalled() || installWasDismissed()) return;

  event.preventDefault();
  deferredPrompt = event;

  androidInstallBanner
    .querySelector(".btn")
    .addEventListener("click", async () => {
      if (!deferredPrompt) return;

      deferredPrompt.prompt();

      await deferredPrompt.userChoice;

      deferredPrompt = null;
    });

  androidInstallBanner.classList.remove("d-none");
});

// PWA iOS support
if (isIOS() && !isPWAInstalled() && !installWasDismissed()) {
  iosInstallBanner.classList.remove("d-none");
}

window.addEventListener("appinstalled", () => {
  androidInstallBanner.classList.add("d-none");
  iosInstallBanner.classList.add("d-none");
});

// PWA dismiss
function installWasDismissed() {
  const timestamp = localStorage.getItem(INSTALL_DISMISSED_KEY);
  if (!timestamp) return false;

  const age = Date.now() - Number(timestamp);
  // return age < INSTALL_DISMISS_DAYS * 24 * 60 * 60 * 1000;
  // seconds for testing!
  return age < INSTALL_DISMISS_DAYS * 1000;
}

function dismissInstallPrompt() {
  localStorage.setItem(
    INSTALL_DISMISSED_KEY,
    Date.now().toString()
  );
}

androidInstallBanner?.addEventListener("closed.bs.alert", () => {
  dismissInstallPrompt();
});

iosInstallBanner?.addEventListener("closed.bs.alert", () => {
  dismissInstallPrompt();
});
